import * as angular from 'angular';

import { IDispatcherService, IDispatcher } from '../';
import { IGroupActionsService } from './groups.actionCreator';
import { Group, CreateGroupFromGroupDto, GroupFromTags } from '../../models';

export interface IGroupsStoreService {
    getOne(guid: string): angular.IPromise<Group>;
    getAll(): angular.IPromise<Group[]>;
    getAll(force: boolean): angular.IPromise<Group[]>;
    create(group: Group): angular.IPromise<Group>;
    update(group: Group): angular.IPromise<Group>;
    duplicate(data: CreateGroupFromGroupDto): angular.IPromise<Group[]>;
    delete(groupGuid: string): angular.IPromise<Group>;
    forceInMemoryUpdate(group: Group): angular.IPromise<Group>;
    updateAllOccurenceMatrix(): angular.IPromise<{ [name: string]: string }>;
    updateSomeOccurenceMatrix(guidList: string[]): angular.IPromise<{ [name: string]: string }>;
    createOrUpdateWithTags(groupFromTags: GroupFromTags): angular.IPromise<Group>;
}

export interface IGroupsActionDispatcherService extends IDispatcherService<IGroupsStoreService> { }

export class GroupsActionDispatcherService implements IGroupsActionDispatcherService {
    static serviceId = 'groupsActionDispatcherService';

    static $inject = ['groupActionsService'];

    constructor(private _actionService: IGroupActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IGroupsStoreService> {
        const as = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(as.getOne(guid)),
                getAll: (force?: boolean) => dispatch(as.getAll(force)),
                create: (group: Group) => dispatch(as.create(group)),
                update: (group: Group) => dispatch(as.update(group)),
                duplicate: (data: CreateGroupFromGroupDto) => dispatch(as.duplicate(data)),
                delete: (groupGuid: string) => dispatch(as.delete(groupGuid)),
                forceInMemoryUpdate: (group: Group) => dispatch(as.forceInMemoryUpdate(group)),
                updateAllOccurenceMatrix: () => dispatch(as.updateAllOccurenceMatrix()),
                updateSomeOccurenceMatrix: (guids: string[]) => dispatch(as.updateSomeOccurenceMatrix(guids)),
                createOrUpdateWithTags: (groupFromTags: GroupFromTags) => dispatch(as.createOrUpdateWithTags(groupFromTags))
            }
        };
    }
}